import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { reduxForm, formValueSelector } from 'redux-form';
import { notification } from 'antd';
import { withRouter } from 'react-router';
import get from 'lodash/get';
import last from 'lodash/last';
import { isOpen } from '../store/modal/selectors';
import { modalShow } from '../store/modal/actions';
import Audiences from '../components/pages/Audiences/index';
import { createValidator, required } from '../services/validation';
import { resourceCreateRequest, resourceDeleteSuccess } from '../store/resource/actions';
import { fromEntities, fromResource } from '../store/selectors';
import { startPollingForQueryStatus } from '../store/audiences/actions';

const AudiencesContainer = props => <Audiences {...props} />;

AudiencesContainer.propTypes = {
  runAudienceQuery: PropTypes.func.isRequired,
  showBigQueryModal: PropTypes.func.isRequired,
};

const mapStateToProps = ({ modal, ...state }) => {
  const queryResponse = fromEntities.getDetail(
    state,
    'theTradeDeskQuery',
    last(fromResource.getList(state, 'theTradeDeskQuery'))
  );

  const checkResponse = fromEntities.getDetail(
    state,
    'theTradeDeskCheck',
    fromResource.getDetail(state, 'theTradeDeskCheck')
  );

  return {
    visible: isOpen(modal, 'create-big-query'),
    checkResponse,
    queryResponse,
    isPolling: get(state, 'audiences.pollingForQuery'),
    deviceGroupName: formValueSelector('Audiences')(state, 'deviceGroupName'),
    deviceCount: get(queryResponse, 'deviceCount', 0),
    queryUuid: get(queryResponse, 'uuid'),
  };
};

const mapDispatchToProps = dispatch => ({
  clearQueries: () => Promise.all([dispatch(resourceDeleteSuccess('the-trade-desk/check'))]),
  runAudienceQuery: data => dispatch(resourceCreateRequest('the-trade-desk/query', {}, data)),
  pollForQueryStatusStart: uuid =>
    dispatch(
      startPollingForQueryStatus({
        params: {},
        uuid,
        endpoint: `the-trade-desk/check`,
      })
    ),
  showBigQueryModal: () => dispatch(modalShow('create-big-query')),
});

const onSubmit = (values, dispatch, props) => {
  const { query, deviceGroupName, advertiserId } = values;

  // Clear history of UUIDs / Scans before running a new one
  props.clearQueries();

  return props
    .runAudienceQuery({
      query,
      options: {
        dryRun: false,
        useStandardSql: get(values, 'useStandardSql', false),
      },
      metadata: {
        advertiserId,
        segment: deviceGroupName,
        daidColumn: 'devices',
      },
    })
    .then(props.pollForQueryStatusStart)
    .catch(e => {
      notification.error({
        message: 'Error',
        description: typeof e === 'string' ? e : 'Whoops! Your Device Group could not be uploaded',
        duration: 0,
      });
    });
};

const validate = createValidator({
  deviceGroupName: [required],
  advertiserId: [required],
  query: [required],
});

export default compose(
  withRouter,
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  reduxForm({
    form: 'Audiences',
    validate,
    onSubmit,
  })
)(AudiencesContainer);
